import { render } from "./ManaGements.vue?vue&type=template&id=dadb4456"
const script = {}

import "./ManaGements.vue?vue&type=style&index=0&id=dadb4456&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__